import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Ruta/editRuta`, method: 'POST', body: values, token: token})
}
